import { useMutation } from '@tanstack/react-query';
import { ApiService } from '@/_services/api.service';
import { useStreamingMessage } from '../streaming/useStreamingMessage';
import { useMessagesCache } from '../queries/useMessagesStore';

/**
 * Mutation hook to load messages for a conversation
 * Uses streaming to load all messages and potentially generate a response
 * if the last message was from the user
 */
export const useLoadMessages = () => {
	const { startMessageStream } = useStreamingMessage();
	const { clearMessages } = useMessagesCache();

	return useMutation({
		mutationFn: async (conversationId: string) => {
			return conversationId;
		},
		onSuccess: (conversationId) => {
			// Start streaming with beforeStart callback to clear messages
			// clearMessages only runs if the stream actually starts (passes the guard)
			startMessageStream(
				async (signal) => ApiService.GetMessagesWithStreaming({ conversationId, signal }),
				{ conversationId, suppressLockErrors: true, suppressNotification: true },
				() => clearMessages(conversationId)
			);
		}
	});
};
